import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import SymbioticEnergyTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import symbioticEnergyIcon from "../../../../../assets/design-revamp-company/category-icons/symbiotic_energy_icon.svg";
const SymbioticEnergyContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("SYMBIOTIC_INPUTS")}
        scope={"Scope 2 (1)"}
        subDescription={t("DESC_SYMBIOTIC")}
        isNormal={true}
        number={"2.3"}
        icon={symbioticEnergyIcon}
      />

      {showTable && <SymbioticEnergyTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default SymbioticEnergyContents;
